module.exports = __webpack_public_path__ + "static/media/ideal.156b148e.svg";